import React from 'react';
import { useCommon } from 'src/AppState/Common';
import { PLAYER_MANAGEMENT_ROOT } from 'src/domains/casino/utils/test-variables';
import { CampaignCreatorState } from 'src/domains/casino/webview/bonus-engine/campaign/CampaignCreator.state';
import { EligibleUsersTable } from 'src/domains/casino/webview/bonus-engine/campaign/player-management/eligible-users/EligibleUsersTable';
import { EligibleUsersUploadArea } from 'src/domains/casino/webview/bonus-engine/campaign/player-management/eligible-users/upload-area/EligibleUsersUploadArea';
import { Input } from 'src/domains/common/components/input/input';
import { Select } from 'src/domains/common/components/select/select';
import { observer } from 'src/utils/mobx-react';
interface PlayerManagementPropsType {
    campaignId?: string;
}

export const PlayerManagement = observer('PlayerManagement', (props: PlayerManagementPropsType): JSX.Element => {
    const common = useCommon();
    const { playerManagementState, editionDisabled } = CampaignCreatorState.get(common, props.campaignId);
    const {
        playerType,
        allPlayersOptions,
        isSegmentedPlayerSelected,
        eligibleUsersState,
        minCustomerSf,
        maxCustomerSf,
    } = playerManagementState;

    const { tableState, playerIdsCsvForm, handleClearAllPlayerIds, removePlayerId } = eligibleUsersState;

    return (
        <div
            className='grid grid-cols-2 gap-2'
            data-test={PLAYER_MANAGEMENT_ROOT}
        >
            <div className='flex flex-col gap-8'>
                <section
                    data-test='player-type'
                    className='flex flex-col gap-6 text-lg'
                >
                    <h2 className='m-0 text-[1rem] font-semibold leading-[1.75]'>Player Type</h2>
                    <div className='flex flex-col gap-4'>
                        <Select
                            dataTest='player-type-dropdown'
                            formInputState={playerType}
                            label='Player Type'
                            placeholder='Select'
                            values={allPlayersOptions}
                            errors={playerType.errorsForView}
                            disabled={editionDisabled}
                        />
                    </div>
                </section>
                {isSegmentedPlayerSelected && (
                    <section
                        data-test='eligible-users'
                        className='flex flex-col flex-auto max-h-screen gap-6 text-lg'
                    >
                        <h2 className='m-0 text-[1rem] font-semibold leading-[1.75]'>Eligible Users</h2>
                        <EligibleUsersUploadArea
                            eligibleUsersState={eligibleUsersState}
                            disabled={editionDisabled}
                        />

                        <EligibleUsersTable
                            state={tableState}
                            form={playerIdsCsvForm}
                            onDelete={removePlayerId}
                            onDeleteAll={handleClearAllPlayerIds}
                            disabled={editionDisabled}
                        />
                    </section>
                )}
                <section
                    data-test='customer-stake-factor'
                    className='flex flex-col gap-6 text-lg'
                >
                    <h2 className='m-0 text-[1rem] font-semibold leading-[1.75]'>Customer SF</h2>
                    <div className='flex flex-row gap-4 flex-nowrap'>
                        <Input
                            description='Enter a decimal value. Min is 0.01'
                            formInputState={minCustomerSf}
                            label='Min Customer SF (Optional)'
                            placeholder='Type'
                            errors={minCustomerSf.errorsForView}
                            disabled={editionDisabled}
                        />
                        <Input
                            description='Enter a decimal value. Max is 100'
                            formInputState={maxCustomerSf}
                            label='Max Customer SF (Optional)'
                            placeholder='Type'
                            errors={maxCustomerSf.errorsForView}
                            disabled={editionDisabled}
                        />
                    </div>
                </section>
            </div>
        </div>
    );
});
